var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.form.loading),expression:"form.loading"}],staticClass:"system-single-login-container",attrs:{"direction":"vertical"}},[_c('base-header',_vm._b({},'base-header',_vm.headers,false)),_c('base-form',_vm._b({attrs:{"options":{
      ftpOptions: _vm.ftpOptions,
      ossOptions: _vm.ossOptions
    }},on:{"handleConfirm":_vm.handleConfirm}},'base-form',_vm.form,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }